/* eslint-disable max-len */
import React, { useState } from 'react'
import {
  MultiselectContainer, CheckboxLabel, CheckboxInput, CheckboxWrapper, StyledCheckbox,
} from './styles'

interface MultiselectOption {
  label: string;
  subOptions?: string[];
}

interface MultiselectProps {
  options: MultiselectOption[];
  onSelect: any;
}

const Multiselect: React.FC<MultiselectProps> = ({ options, onSelect }) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])

  const handleOptionClick = (label: string) => {
    if (onSelect) {
      onSelect(label)
    }
    const isSelected = selectedOptions.includes(label)
    setSelectedOptions((prevSelected) => (isSelected ? prevSelected.filter((option) => option !== label) : [...prevSelected, label]))
  }

  return (
    <div>
      {options.map((option) => (
        <MultiselectContainer key={option.label}>
          <CheckboxWrapper>
            <CheckboxInput
              type="checkbox"
              checked={selectedOptions.includes(option.label)}
              onChange={() => handleOptionClick(option.label)}
            />
            <StyledCheckbox isChecked={selectedOptions.includes(option.label)} />
            <CheckboxLabel onClick={() => handleOptionClick(option.label)}>
              {option.label}
            </CheckboxLabel>
          </CheckboxWrapper>

          {selectedOptions.includes(option.label) && option.subOptions && (
            <div style={{ marginLeft: '30px' }}>
              {option.subOptions.map((subOption) => (
                <CheckboxWrapper key={subOption}>
                  <CheckboxInput
                    type="checkbox"
                    checked={selectedOptions.includes(subOption)}
                    onChange={() => handleOptionClick(subOption)}
                  />
                  <StyledCheckbox isChecked={selectedOptions.includes(subOption)} />
                  <CheckboxLabel onClick={() => handleOptionClick(subOption)}>
                    {subOption}
                  </CheckboxLabel>
                </CheckboxWrapper>
              ))}
            </div>
          )}
        </MultiselectContainer>
      ))}
    </div>
  )
}

export default Multiselect
